<div class="vox-table equipment-table">
    <table>
        <thead>
            <tr>
                <td translate class="sortable">
                    <!-- TODO: add this code when backend sorting is ready
                        (click)="toggleSort('mac_address')" -->
                    <div class="label-container">
                        <span translate>equipment.table.mac-address.label</span>
                        <i *ngIf="sort.mac_address" class="icon-small-arrow-dropdown"
                            [ngClass]="{'asc':sort.mac_address === 'asc' }"></i>
                    </div>
                </td>
                <td translate class="sortable">
                    <!-- TODO: add this code when backend sorting is ready
                        (click)="toggleSort('model')" -->
                    <div class="label-container">
                        <span translate>equipment.table.model.label</span>
                        <i *ngIf="sort.model" class="icon-small-arrow-dropdown"
                            [ngClass]="{'asc':sort.model === 'asc' }"></i>
                    </div>
                </td>
                <td translate class="sortable">
                    <!-- TODO: add this code when backend sorting is ready
                        (click)="toggleSort('status')" -->
                    <div class="label-container">
                        <span translate>equipment.table.status.label</span>
                        <i *ngIf="sort.status" class="icon-small-arrow-dropdown"
                            [ngClass]="{'asc':sort.status === 'asc' }"></i>
                    </div>
                </td>
                <td translate class="sortable">
                    <!-- TODO: add this code when backend sorting is ready
                        (click)="toggleSort('alphaname')" -->
                    <div class="label-container">
                        <span translate>equipment.table.alphaname.label</span>
                        <i *ngIf="sort.alphaname" class="icon-small-arrow-dropdown"
                            [ngClass]="{'asc':sort.alphaname === 'asc' }"></i>
                    </div>
                </td>
                <td translate class="sortable">
                    <!-- TODO: add this code when backend sorting is ready
                        (click)="toggleSort('company_id')" -->
                    <div class="label-container">
                        <span translate>equipment.table.company-id.label</span>
                        <i *ngIf="sort.company_id" class="icon-small-arrow-dropdown"
                            [ngClass]="{'asc':sort.company_id === 'asc' }"></i>
                    </div>
                </td>
                <td translate class="sortable">
                    <!-- TODO: add this code when backend sorting is ready
                        (click)="toggleSort('pbx_id')" -->
                    <div class="label-container">
                        <span translate>equipment.table.pbx-id.label</span>
                        <i *ngIf="sort.pbx_id" class="icon-small-arrow-dropdown"
                            [ngClass]="{'asc':sort.pbx_id === 'asc' }"></i>
                    </div>
                </td>
                <td translate>equipment.table.user-name.label</td>
                <td translate>equipment.table.user-email.label</td>
                <td translate>equipment.table.user-extension.label</td>
                <td translate>equipment.table.actions.label</td>
            </tr>
        </thead>
        <tbody *ngIf="!loading">
            <tr *ngFor="let equipment of equipmentList">
                <td>{{equipment.mac_address}}</td>
                <td>{{equipment.model}}</td>
                <td>
                    <gdp-equipment-status [status]="equipment.status"></gdp-equipment-status>
                </td>
                <td><span *ngIf="equipment.pbx">{{equipment.pbx.alphaname}}</span></td>
                <td><a *ngIf="equipment.pbx"
                        [routerLink]="['/dashboard/companies/',equipment.pbx.company_id]">{{equipment.pbx.company_id}}</a>
                </td>
                <td><span *ngIf="equipment.pbx">{{equipment.pbx.id}}</span></td>
                <td>
                    <span *ngIf="equipment.user && equipment.model !== 'AIR'">{{equipment.user.first_name}}
                        {{equipment.user.last_name}}</span>
                    <span *ngIf="equipment.model === 'AIR'">N.A.</span>
                </td>
                <td>
                    <span *ngIf="equipment.user && equipment.model !== 'AIR'"><a
                            href="mailto:{{equipment.user.email}}">{{equipment.user.email}}</a></span>
                    <span *ngIf="equipment.model === 'AIR'">N.A.</span>
                </td>
                <td>
                    <span *ngIf="equipment.user && equipment.model !== 'AIR'">{{equipment.user.extension.number}}</span>
                    <span *ngIf="equipment.model === 'AIR'">N.A.</span>
                </td>
                <td>
                    <button class="vox-btn vox-btn-secondary" [routerLink]="[equipment.mac_address]"
                        translate>equipment.table.actions.button</button>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="loading">
            <tr *ngFor="let i of loadingLines">
                <td colspan="10">
                    <ngx-skeleton-loader></ngx-skeleton-loader>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="!loading && equipmentList.length === 0">
            <tr>
                <td class="empty-table" colspan="10" translate>equipment.table.empty</td>
            </tr>
        </tbody>
    </table>
</div>